module.exports = __webpack_public_path__ + "static/media/logo.fff653d9.png";